import { render, staticRenderFns } from "./questionPaperRecord.vue?vue&type=template&id=49939127&scoped=true"
import script from "./questionPaperRecord.vue?vue&type=script&lang=js"
export * from "./questionPaperRecord.vue?vue&type=script&lang=js"
import style0 from "./questionPaperRecord.vue?vue&type=style&index=0&id=49939127&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49939127",
  null
  
)

export default component.exports